import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;

export { useAppStore } from './app';
export { useAuthStore } from './auth';
export { useComponentStore } from './component';
export { useComponentTypeStore } from './componentType';
export { useMeasureTypeStore } from './measureType';
export { useRecipeStore } from './recipe';
export { useProductionOrderStore } from './productionOrder';
export { useWarehouseStore } from './warehouse';
export { useStationTypeStore } from './stationType';
export { useRouteStore } from './route';
export { useStationStore } from './station';
export { useWipStore } from './wip';
export { useStepExecutionStore } from './stepExecution';
